/**
 * ClickUp Task status.
 */
export enum ClickUpStatus {
	Pending = "Pendente"
}